import Typography from '@ixigo/iui/Typography';
import clsx from 'clsx';
import { FC, useEffect, useMemo, useState } from 'react';
import { getChats } from '../../apis/conversation';
import ChatCard from '../ChatCard';
import EmptyPage from '../EmptyPage';
import FullScreenError from '../Error/FullScreen';
import SpinnerLoader from '../Loader/Spinner';
import { AllChatsProps, ChatThread } from './index.types';

const AllChats: FC<AllChatsProps> = ({ showOnlyActiveChats }) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [data, setData] = useState<ChatThread[]>([]);

    const fetchChats = async () => {
        try {
            const response = await getChats(!!showOnlyActiveChats);
            setData(response);
        } catch (e) {
            setError(true);
        } finally {
            setLoading(false);
        }
    };

    const activeChats = useMemo(() => data.filter((chat) => chat.active), [data]);

    const inactiveChats = useMemo(() => data.filter((chat) => !chat.active), [data]);

    useEffect(() => {
        fetchChats();
    }, []);

    if (loading) {
        return <SpinnerLoader className='grow justify-center min-h-[calc(100vh-210px)]' />;
    }

    if (error) return <FullScreenError />;

    if (!data.length) {
        return <EmptyPage heading='No chats available!' subHeading='There are no past chat threads to show.' />;
    }

    return (
        <>
            {activeChats.map((chat) => (
                <ChatCard key={chat._id} data={chat} />
            ))}
            {inactiveChats.length > 0 && (
                <>
                    {!showOnlyActiveChats && (
                        <Typography
                            variant='h4'
                            fontWeight='medium'
                            className={clsx(activeChats.length > 0 && 'mt-15')}
                        >
                            Resolved
                        </Typography>
                    )}
                    {inactiveChats.map((chat) => (
                        <ChatCard key={chat._id} data={chat} />
                    ))}
                </>
            )}
        </>
    );
};

export default AllChats;
